import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const ContactUsPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, email, message } = formData;

        if (!name || !email || !message) {
            setError('Please fill in all fields.');
            setMessage('');
        } else {
            setError('');
            setMessage('Thank you for your message! We will get back to you shortly.');
            // Using the mailto link to open the user's email client with a prefilled message
            window.location.href = `mailto:admin@dnacloudhub.com?subject=Contact%20Us%20Message&body=Name:%20${name}%0AEmail:%20${email}%0AMessage:%20${message}`;
        }
    };

    return (

        <>
            <Helmet>
                <title>DNACloudHub | Contact Us</title>
                <meta name="description" content="Get in touch with the DNACloudHub team for support, inquiries, or feedback. We’re here to assist with any questions about our cloud-based platform for running qpAdm models and genetic analysis." />
                <meta property="og:title" content={'DNACloudHub | Contact Us'} />
                <meta property="og:description" content={'"Get in touch with the DNACloudHub team for support, inquiries, or feedback. We’re here to assist with any questions about our cloud-based platform for running qpAdm models and genetic analysis."'} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://dnacloudhub.com/contact_us`} />
            </Helmet>

            <Container className="my-5" style={{ textAlign: 'left' }}>

                <Row className="justify-content-center">
                    <Col md={6}>
                        <h2 className="text-center mb-4">Contact Us</h2>

                        {/* Display error or success message */}
                        {error && <Alert variant="danger">{error}</Alert>}
                        {message && <Alert variant="success">{message}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            {/* Name Field */}
                            <Form.Group controlId="formName">
                                <Form.Label>Your Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Enter your name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            {/* Email Field */}
                            <Form.Group controlId="formEmail">
                                <Form.Label>Your Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="Enter your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            {/* Message Field */}
                            <Form.Group controlId="formMessage">
                                <Form.Label>Your Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="message"
                                    rows={5}
                                    placeholder="Type your message here..."
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            {/* Submit Button */}
                            <Button variant="primary" type="submit" block>
                                Send Message
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ContactUsPage;
